var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Offers } from '@shared-ui/retail-activities-offers';
import { updateSearch } from 'bernie-core';
import { useHistory, useLocation } from 'react-router-dom';
import { useStores } from '../../../../utils/hooks';
import { NavigationRefs } from '../../../../utils/accessibility';
export var OffersComponent = function (_a) {
  var className = _a.className,
    oneKeyToggleState = _a.oneKeyToggleState,
    skipSsr = _a.skipSsr;
  var _b = useStores(),
    tripCreationStore = _b.tripCreationStore,
    _c = _b.detailCriteriaStore,
    activityId = _c.activityId,
    _d = _c.detailVariables,
    dateRange = _d.dateRange,
    destination = _d.destination,
    detailsViewOptions = _d.detailsViewOptions,
    detailCriteriaStore = _b.detailCriteriaStore;
  var history = useHistory();
  var location = useLocation();
  var onSwpToggle = function (isChecked) {
    var swpValue = isChecked ? 'on' : 'off';
    updateSearch({
      history: history,
      location: location,
      newParams: {
        swp: swpValue
      },
      newState: {},
      replace: true
    });
    detailCriteriaStore.detailQuery = __assign(__assign({}, detailCriteriaStore.detailQuery), {
      swp: swpValue
    });
  };
  var createTripOnClick = function (tripRequest) {
    return tripCreationStore.createTripV2(tripRequest);
  };
  skipSsr = skipSsr || false;
  return React.createElement(Offers, {
    className: className,
    skipSsr: skipSsr,
    inputs: {
      activityId: activityId,
      dateRange: dateRange,
      destination: destination,
      detailsViewOptions: detailsViewOptions
    },
    createTripOnClick: createTripOnClick,
    jumplinkTabRefs: NavigationRefs,
    onSwpToggle: onSwpToggle,
    oneKeyToggleState: oneKeyToggleState
  });
};